export const home = {
  'Made for': 'Made for',
  'New releases': 'New releases',
  MUSIC: 'Music',
  ALL: 'All',
  PODCASTS: 'Podcasts',
  FOLLOWING: 'Following',
  'Podcast following title': "You don't follow any podcasts yet",
  'Podcast following description': 'Follow your favorite podcasts to stay up to date.',
  'Explore podcasts': 'Explore podcasts',
  'More like': 'More like',
  'Episodes you might like': 'Episodes you might like',
  'Episodes to try': 'Episodes to try',
  ARTISTS: 'Artists',
  SONGS: 'Songs',
  ALBUMS: 'Albums',
  TRACKS: 'Songs',
  PLAYLISTS: 'Playlists',
  you: 'you',
  'Made for you': 'Made for you',
};
